import React, { useState, useEffect } from 'react'
import EditGroup from 'srcReact/GroupPage/CreateUpdateGroup/EditGroup'
import CreateGroup from 'srcReact/GroupPage/CreateUpdateGroup/CreateGroup'
import { isNum } from 'srcReact/helpers/utils'

function CreateUpdateGroup(props) {
  const [editMode, setEditMode] = useState(false)

  useEffect(() => {
    const groupIdParam = props.match.params.groupId
    if (groupIdParam && isNum(groupIdParam)) {
      setEditMode(true)
    } else {
      setEditMode(false)
    }
  }, [])

  return editMode ? <EditGroup {...props} /> : <CreateGroup {...props} />
}

export default CreateUpdateGroup
